import { Component, Host, h, Prop, Fragment } from '@stencil/core';
import { getClosingHourFromBank } from '../../../../global/utility/get-closing-hour-from-bank';
import { SearchResponseEntry } from '../../../../../types/global'; // eslint-disable-line import/extensions
import store from '../../../../global/store';
import { tracker } from '../../../../global/tracker';

@Component({
  tag: 'ui-bank-search-mobile-item',
  styleUrl: 'ui-bank-search-mobile-item.scss',
  shadow: false,
})
export class UiBankSearchMobileItem {
  @Prop() bank: SearchResponseEntry;

  onInfoBoxClick() {
    store.state.selectedBank = this.bank;
    store.state.isOverlayVisible = true;
    tracker.trackBankSelect('Teaser');
    tracker.trackInitialFormPage(this.bank?.bankCode, this.bank?.name);
  }

  render() {
    const {
      thumbnail,
      name,
      street,
      city,
      zipCode,
      phoneArea,
      phoneNumber,
      distance,
    } = this.bank;

    const phone = `${phoneArea} ${phoneNumber}`;

    const location = `${zipCode} ${city}`;

    return (
      <Host
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            this.onInfoBoxClick();
          }
        }}
        onPointerEnter={() => {
          store.state.isSliderCondensed = false;
        }}
        onClick={this.onInfoBoxClick.bind(this)}
        class={{
          selected: this.bank.id === store.state.selectedBank?.id,
          'slider-condensed': store.state.isSliderCondensed,
        }}
      >
        <div class="icon">
          <ui-cms-image
            alt="bank logo"
            src={
              thumbnail !== null
                ? thumbnail
                : `${store.state.assetsUrl}/bank-fallback.png`
            }
          ></ui-cms-image>
        </div>
        <div class="description">
          <div class="description__name">{name}</div>
          {!store.state.isSliderCondensed ? (
            <Fragment>
              <div class="description__address">
                <p>{street}</p>
                <p>{location}</p>
              </div>
              {phone !== 'null null' && phone !== ' ' ? (
                <div class="description__phone">
                  <b>Telefon: </b>
                  <span class="description__phone-number">{phone}</span>
                </div>
              ) : (
                ''
              )}
              <p class="description__opening-hours">
                {getClosingHourFromBank(this.bank)
                  ? `${(window as any).ui.services?.i18n?.translate('bankSearch').openingHoursOpen || 'Geöffnet'}: ${(window as any).ui.services?.i18n?.translate('bankSearch').openingHoursToday || 'Heute'} ${(window as any).ui.services?.i18n?.translate('bankSearch').openingHoursTo || 'bis'} ${getClosingHourFromBank(this.bank)} ${(window as any).ui.services?.i18n?.translate('bankSearch').clock || 'Uhr'}`
                  : ''}
              </p>
            </Fragment>
          ) : (
            ''
          )}
        </div>
        <p class="distance">{distance !== 0 ? `${distance},00 km` : ''}</p>
      </Host>
    );
  }
}
